/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React, { useContext } from 'react';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';

import EntrySelector from './EntrySelector';
import EmptyData from './EmptyData';
import { CardContext } from '../CardContext';
import { Box } from '@material-ui/core';

/**
 * Body section of the summary card that presents the content entries based on their type with the help
 * of the <EntrySelector/> component.
 * A custom empty layout is displayed for no entries.
 *
 * @returns {JSX.Element}
 */
export default function CardBody({ customClassName }) {
  const { entries, readOnly } = useContext(CardContext);

  return (
    <CardContent>
      <Box>
        {entries?.length > 0 ? (
          entries.map((entry, index) => {
            return (
              <EntrySelector
                key={`${entry?.title}-${index}`}
                entry={entry}
                index={index}
                readOnly={readOnly}
                customClassName={customClassName}
              />
            );
          })
        ) : (
          <EmptyData />
        )}
      </Box>
    </CardContent>
  );
}
